import React, { useState, useEffect } from "react";

const RealTimeClock = () => {
  const [dateTime, setDateTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setDateTime(new Date());
    }, 1000); // Update every second

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  return (
    <div>
      {/* <h2>Date & Time</h2> */}
      <p>{dateTime.toLocaleDateString()} {dateTime.toLocaleTimeString()}</p>
    </div>
  );
};

export default RealTimeClock;
